import React from "react";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
  Dropdown,
  Form,
  FormGroup,
  Input,
  Button,
  Row,
} from "reactstrap";

function ExamplesNavbar() {
  const [isOpen, setIsOpen] = React.useState(false);

  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} color="info" expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              target="_blank"
              id="navbar-brand"
            >
              Laroca Hotels
            </NavbarBrand>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              <NavItem>
                <Dropdown toggle={() => setIsOpen(!isOpen)} isOpen={isOpen}>
                  <DropdownToggle
                    caret
                    color="neutral"
                    nav
                    onClick={(e) => e.preventDefault()}
                    data-toggle="dropdown"
                    tag="span"
                    style={{ color: "white" }}
                  >
                    <i className="now-ui-icons design_app mr-1"></i>
                    login
                  </DropdownToggle>
                  <DropdownMenu>
                    <Form action="http://res.larocahotels.com/" method="post">
                      <Container>
                        <Row className="formRow">
                          <Input
                            autoFocus={true}
                            name="txtAgency_ext"
                            defaultValue=""
                            placeholder="Agency Id"
                            type="text"
                          ></Input>
                        </Row>
                        <Row className="formRow">
                          <Input
                            name="txtUsername_ext"
                            defaultValue=""
                            placeholder="Username"
                            type="text"
                          ></Input>
                        </Row>
                        <Row className="formRow">
                          <Input
                            name="txtPassword_ext"
                            defaultValue=""
                            placeholder="Psasword"
                            type="password"
                          ></Input>
                        </Row>
                        <Row className="formRow">
                          <Button color="info" size="sm">
                            Login
                          </Button>
                        </Row>
                      </Container>
                    </Form>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  href="https://www.facebook.com/profile.php?id=100091826363195"
                  target="_blank"
                  id="facebook-tooltip"
                >
                  <i className="fab fa-facebook-square"></i>
                  <p className="d-lg-none d-xl-none">Facebook</p>
                </NavLink>
                <UncontrolledTooltip target="#facebook-tooltip">
                  Like us on Facebook
                </UncontrolledTooltip>
              </NavItem> */}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ExamplesNavbar;
